export const HTTP_PROTOCOL = '/http/1.1'
export const PEER_ID_AUTH_SCHEME = 'libp2p-PeerID'
export const HTTP_PEER_ID_AUTH_PROTO = '/http-peer-id-auth/1.0.0'
export const DEFAULT_COOKIE_EXPIRY_CHECK_INTERVAL = 60_000
export const WEBSOCKET_HANDLER = Symbol.for('@libp2p/http/websocket-handler')
